import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { initializeMobileInterface } from './utils/native-interface.ts';

initializeMobileInterface();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
